// extracted by mini-css-extract-plugin
export var container = "styles-module--container--kj+eD";
export var title = "styles-module--title--819Bg";
export var description = "styles-module--description--ByRUa";